import { Box, Grid, Typography } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";
import api from "../services/Axios";
import { useEffect, useState } from "react";

const PIE_COLORS = ["#2979FF", "#66BB6A", "#EC407A", "#FFA726", "#5C6BC0", "#AB47BC", "#26A69A"];
const CHART_STYLE = {
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    border: "1px solid #EEF0F5",
    boxShadow: "0 2px 8px rgba(17,19,26,0.04)",
};

export default function NewUsersByChannel({ dateRange, onLoadingChange }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const requestId = `new-users-channel-${Date.now()}-${Math.random()}`;
            setLoading(true);
            onLoadingChange(requestId, true);
            try {
                const res = await api.get("/admin/analytics/ga/new-users-by-channel", { params: dateRange });
                if (!cancelled) setRows(res?.data?.rows || []);
            } finally {
                if (!cancelled) setLoading(false);
                onLoadingChange(requestId, false);
            }
        })();
        return () => { cancelled = true; };
    }, [dateRange, onLoadingChange]);

    return (
        <Grid item xs={12} md={6}>
            <Box borderRadius={2} p={2.5} sx={CHART_STYLE} height="100%">
                <Typography variant="h6" mb={2}>New users by channel</Typography>

                {!loading && (
                    <ResponsiveContainer width="100%" height={320}>
                        <PieChart>
                            <Pie data={rows} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={90} paddingAngle={2}>
                                {rows.map((_, i) => (
                                    <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                )}
            </Box>
        </Grid>
    );
}
